import { TextAlign } from '@view-model/models/common/text-align';

const PADDING_RATIO = 0.12;
const LINE_SPACING_RATIO = 0.17;
const FULL_LINE_RATIO = 0.85;
const MIN_LAST_LINE_RATIO = 0.3;

type Props = {
  width: number;
  height: number;
  text: string;
  textAlign: TextAlign;
};

export const countPlaceholderLines = (text: string): number => {
  const length = text.trim().length;
  if (length === 0) return 0;
  if (length <= 8) return 1;
  if (length <= 24) return 2;
  return 3;
};

/**
 * ズームアウトして文字が読めない間、文字が書かれている雰囲気を伝えるための線。
 * 文字の長さに応じて 1〜3 行の線を引く。太さは拡大率に依らず画面上で一定にする。
 * 画像エクスポートでは SVG ルートの data-lod が外されるため、CSS で非表示になり、文字に重ならない（index.css）。
 */
export const NodeTextPlaceholder: React.FC<Props> = ({ width, height, text, textAlign }: Props) => {
  const lineCount = countPlaceholderLines(text);
  if (lineCount === 0) return null;

  const innerWidth = width * (1 - PADDING_RATIO * 2);
  const fullLength = innerWidth * FULL_LINE_RATIO;
  const lastRatio = Math.max(MIN_LAST_LINE_RATIO, Math.min(1, (text.trim().length % 12 || 12) / 12));
  const spacing = height * LINE_SPACING_RATIO;
  const firstY = height / 2 - (spacing * (lineCount - 1)) / 2;

  const commands = Array.from({ length: lineCount }, (_, index) => {
    const length = index === lineCount - 1 && lineCount > 1 ? fullLength * lastRatio : fullLength;
    const x = (() => {
      switch (textAlign) {
        case TextAlign.Left:
          return width * PADDING_RATIO;
        case TextAlign.Right:
          return width * (1 - PADDING_RATIO) - length;
        default:
          return (width - length) / 2;
      }
    })();
    const y = firstY + spacing * index;
    return `M${x} ${y}h${length}`;
  }).join('');

  return (
    <path
      d={commands}
      className="lod-placeholder pointer-events-none"
      fill="none"
      stroke="#000"
      strokeOpacity={0.6}
      strokeWidth={1}
      vectorEffect="non-scaling-stroke"
    />
  );
};
